import {app} from "../../../config/constants";

export const getSettings = () => {
	return app.database().ref( 'cams/settings' ).child('sidebarWidgets').once('value', sidebarWidgetsSettingsSnap => {})
};

export const saveSettings = (settings) => {
	return app.database().ref('cams/settings').child('sidebarWidgets').set(settings);
};


// WEBPACK FOOTER //
// ./src/api/settings/sidebar-widgets/index.js